import React, { useState } from 'react';
import VersionHistoryCopyAppBar from '../../../../common/VersionHistoryCopyAppBar';
import OriginalPreview from '../../../NodeActions/Copy/components/OriginalPreview';
import NewPreview from '../../../NodeActions/Copy/components/NewPreview';
import CopyReplaceConfirmModal from '../../../NodeActions/Copy/components/CopyReplaceConfirmModal';
import Loader from '../../../../common/Loader';
import { showSnackbar } from '../../../../redux/snackbarSlice';

/**
 * PreviewRevision Component
 * Displays preview of original vs new document state for version history copy & replace
 * Reuses existing CopyReplace components for consistency
 */
const PreviewRevision = (props) => {

  console.log("PreviewRevision props:", props)

  const {
    sourceDocument,
    targetDocument,
    originalData = [], // Currently blank array as requested
    newData = [],       // Currently blank array as requested
    onConfirm,
    onCancel,
    isLoading = false
  } = props;

  const [previewMode, setPreviewMode] = useState('new'); // 'original' | 'new'
  const [comment, setComment] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handlePreviewModeChange = (mode) => {
    setPreviewMode(mode);
  };

  const handleCommentChange = (newComment) => {
    setComment(newComment);
  };

  const handleConfirmClick = () => {
    setShowConfirmModal(true);
  };

  const handleModalSave = () => {
    if (onConfirm) {
      onConfirm(comment);
    }
    setShowConfirmModal(false);
  };

  const handleModalClose = () => {
    setShowConfirmModal(false);
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* AppBar with view toggle and confirm button */}
      <VersionHistoryCopyAppBar
        title={`Please Confirm the Changes`}
        showColorTitle={true}
        showBlackTitle={false}
        showCancelButton={true}
        onCancel={handleCancel}
        showBackButton={false}
        showProfileButton={false}
        showTablesDropdown={false}
        showViewToggle={true}
        selectedView={previewMode}
        onViewChange={handlePreviewModeChange}
        buttons={[
          {
            label: 'Confirm',
            onClick: handleConfirmClick,
            disabled: isLoading
          }
        ]}
      />

      {/* Preview Content */}
      <div style={{ padding: '20px' }}>
        {previewMode === 'original' ? (
          <OriginalPreview
            data={originalData}
            targetDocument={targetDocument}
          />
        ) : (
          <NewPreview
            originalData={originalData}
            sourceData={sourceDocument}
            targetDocument={targetDocument}
            newData={newData}
          />
        )}
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <CopyReplaceConfirmModal
          sourceDocument={sourceDocument}
          sourceNode={null} // Not applicable for document copy
          copyMode="document"
          targetDocument={targetDocument}
          pastePosition={null} // Not applicable for document copy
          comment={comment}
          onCommentChange={handleCommentChange}
          onClose={handleModalClose}
          onSave={handleModalSave}
          isLoading={isLoading}
        />
      )}

      {/* Loading overlay */}
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(255,255,255,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Loader text="Processing..." />
        </div>
      )}
    </div>
  );
};

export default PreviewRevision;